import { computed } from 'vue';
import { useRoute } from 'vue-router';

export default function usePrintMode() {
  const route = useRoute();
  const isPrint = computed(() => route?.query?.print !== undefined);
  return { isPrint };
}
